<form [formGroup]="form" (ngSubmit)="onSubmit()">
  <div class="flex flex-column items-center">
    <p class="text-muted-color block mb-4">
      Hemos enviado un código de verificación a tu número
      <span class="font-semibold">{{ inputData.phone }}</span
      >.Ingresa el código recibido para completar tu compra.
    </p>
    <div class="flex justify-content-center">
      <div class="flex flex-column gap-1">
        <p-inputOtp
          formControlName="otp"
          [integerOnly]="true"
          [length]="6"
          id="otp"
          class="justify-content-center"
        />
      </div>
    </div>

    @if(timeLeft){
    <div
      class="flex justify-content-center align-items-center gap-3 mt-4 surface-100 p-3"
    >
      <i class="fa-sharp-duotone fa-solid fa-clock text-muted-color fa-xl"></i>
      <span class="text-muted-color font-medium text-sm"
        >La validez del código es de
        <span class="font-semibold">{{ displayTime }}</span
        >. Si el tiempo expira, deberás presionar en el botón
        <span class="font-semibold">Reenviar</span> para recibir un nuevo
        código.</span
      >
    </div>
    } @else if(hasErrorOnResend()){
    <div
      class="flex justify-content-center align-items-center gap-3 mt-4 bg-red-50 p-3 border-danger border-1"
    >
      <i
        class="fa-sharp-duotone fa-solid fa-triangle-exclamation fa-xl text-red-500"
      ></i>
      <span class="text-muted-color font-medium text-sm"
        >Ha ocurrido un error al intentar reenviar el código de verificación.
        Por favor, intente de nuevo o contacte a soporte técnico.
      </span>
    </div>
    } @else {
    <div
      class="flex justify-content-center align-items-center gap-3 mt-4 bg-red-50 p-3 border-danger border-1"
    >
      <i
        class="fa-sharp-duotone fa-solid fa-triangle-exclamation fa-xl text-red-500"
      ></i>
      <span class="text-muted-color font-medium text-sm"
        >El código de verificación ha expirado. Deberás presionar en el botón
        <span class="font-semibold">Reenviar</span> para recibir un nuevo
        código.</span
      >
    </div>
    }

    <div class="flex mt-4 justify-content-end gap-2">
      @if(!timeLeft){
      <p-button
        type="button"
        [text]="true"
        label="Reenviar"
        (onClick)="resendOtp()"
      />
      }
      <p-button type="submit" label="Confirmar" />
    </div>
  </div>
</form>
